import log from "loglevel"
import { AppDispatch, RootState } from "../../../redux/store"
import { selectCompanies } from "../../../redux/selectors/companies"
import { selectOpenSites } from "../../../redux/selectors/sites"
import { requestResourcesWithRelated } from "../../../datastore"
import { ResourceEvent } from "../../../datastore/types"
import { useTask } from "../../../hooks/useTask"
import { Company, Site } from "../../../datastore/models"

/**
 * 'useResources' hook
 * - Requests resources for page
 * - 'selects' results
 *
 * @returns  requested resources
 */

export const useDocumentsResources = (pageActive: boolean) => {
  const taskResult = useTask(
    async (dispatch: AppDispatch, getState: () => RootState, services: any) => {
      const result = await requestResourcesWithRelated(
        "sites",
        {
          eqFilter: { status: "open" },
          include: ["company"]
        },
        ["projectSites.projects"]
      )(dispatch, getState, services)

      if (result === ResourceEvent.RESOURCE_LOAD_ERROR) {
        log.debug("useDocumentsResources request error")
        return { isSuccess: false }
      }

      const state = getState()
      return {
        isSuccess: true,
        data: {
          companies: selectCompanies(state, {}),
          sites: selectOpenSites(state, {})
        }
      }
    },
    [],
    pageActive
  )

  return {
    companies: taskResult.data?.companies as Company[],
    sites: taskResult.data?.sites as Site[],
    isLoading: taskResult.isLoading,
    isSuccess: taskResult.isSuccess,
    isError: taskResult.isError
  }
}
